import React from "react";
import * as aor from "react-admin";
import CardActions from "@material-ui/core/CardActions";
import StatusChip from "../../components/StatusChip";
import grey from "@material-ui/core/colors/grey";
import AddressLink from "../../components/AddressLink";

import {
    POLICY_CUSTOMERS,
    POLICY_CUSTOMERS_MAPPINGS,
    POLICY_INSTALLATIONS,
    POLICY_NOTIFICATIONS
} from "../../common/rolesManagement";
import MyChipField from "../../components/MyChipField";
import TextField from "@material-ui/core/TextField";
import { getPolicies } from "../../common/authClient";

const PROVISIONING_SUCCEEDED = "PROVISIONING_SUCCEEDED";
const CONFIRMATION_EMAIL_SENT = "CONFIRMATION_EMAIL_SENT";

const Actions = ({ permissions, basePath, data }) => (
    <CardActions style={{ zIndex: 2, display: "inline-block", float: "right" }}>
        {permissions && permissions.includes(POLICY_CUSTOMERS.UPDATE) && (
            <aor.EditButton basePath={basePath} record={data} />
        )}
        <aor.ListButton basePath={basePath} />
    </CardActions>
);
const postRowStyle = (record, index) => ({
    backgroundColor: record && record.disabled ? grey[100] : "white",
    color: record && record.disabled ? grey[400] : "default"
});

const CustomTextField = ({ classes, ...props }) => (
    <aor.TextField
        style={{ color: props.data.disabled ? grey[400] : "black" }}
        record={props.record}
        {...props.textFieldProps}
    />
);
CustomTextField.defaultProps = aor.TextField.defaultProps;

const CustomDirectTextField = ({ classes, ...props }) => (
    <aor.TextField
        style={{ color: props.record.disabled ? grey[400] : "black" }}
        {...props}
    />
);
CustomDirectTextField.defaultProps = aor.TextField.defaultProps;

const CustomReferenceField = ({ ...props }) => (
    <aor.ReferenceField {...props}>
        <CustomTextField {...props} data={props.record} />
    </aor.ReferenceField>
);

CustomReferenceField.defaultProps = aor.ReferenceField.defaultProps;

export default ({ ...props }) => (
    <aor.Show
        {...props}
        actions={<Actions permissions={getPolicies()} />}
        title={"resources.customers.nameSingular"}
    >
        <aor.SimpleShowLayout>
            <aor.TextField source="vatin" />
            <aor.TextField source="name" />
            <AddressLink
                {...props}
                source="email"
                enabled={getPolicies().includes(
                    POLICY_NOTIFICATIONS.SEND_NOTIFICATIONS
                )}
            />
            <aor.FunctionField
                addLabel={false}
                render={record =>
                    record !== undefined &&
                    record.company_ids !== undefined &&
                    record.company_ids.length > 1 ? (
                        <TextField
                            id="total_active_installations"
                            label={"Installazioni attive"}
                            value={record.total_active_installations}
                            margin="normal"
                            InputProps={{ disableUnderline: true }}
                        />
                    ) : null
                }
            />
            <aor.FunctionField
                addLabel={false}
                render={record =>
                    record !== undefined &&
                    record.company_ids !== undefined &&
                    record.company_ids.length > 1 ? (
                        <TextField
                            id="total_licensed_installations"
                            label="Installazioni prenotate"
                            value={record.total_licensed_installations}
                            margin="normal"
                            InputProps={{ disableUnderline: true }}
                        />
                    ) : null
                }
            />
            {/* TODO changes for next sprint */}
            <aor.ReferenceManyField
                label={"resources.customers-mappings.namePlural"}
                perPage={100}
                reference="customers-mappings"
                target="customer_id"
                sort={{ field: "name", order: "ASC" }}
            >
                <aor.Datagrid rowStyle={postRowStyle}>
                    <CustomReferenceField
                        {...props}
                        source="company_id"
                        reference="companies"
                        linkType={false}
                        allowEmpty
                        label="resources.companies.nameSingular"
                        textFieldProps={{
                            source: "name",
                            sortable: false
                        }}
                    />
                    <CustomReferenceField
                        {...props}
                        source="company_id"
                        reference="companies"
                        linkType={false}
                        allowEmpty
                        label="resources.companies.fields.vatin"
                        textFieldProps={{
                            source: "vatin",
                            sortable: false
                        }}
                    />
                    <CustomReferenceField
                        {...props}
                        source="company_id"
                        reference="companies"
                        linkType={false}
                        allowEmpty
                        label="resources.companies.fields.seller_code"
                        textFieldProps={{
                            source: "seller_code",
                            sortable: false
                        }}
                    />
                    <CustomDirectTextField
                        source="booked_installations"
                        sortable={false}
                    />
                    <CustomDirectTextField
                        source="active_installations"
                        sortable={false}
                    />
                    {getPolicies() &&
                        getPolicies().includes(
                            POLICY_CUSTOMERS_MAPPINGS.UPDATE_BOOKED_INSTALLATION
                        ) && <aor.EditButton basePath="/customers-mappings" />}
                </aor.Datagrid>
            </aor.ReferenceManyField>

            {getPolicies() &&
                getPolicies().includes(POLICY_INSTALLATIONS.READ) && (
                    <aor.ReferenceManyField
                        label="resources.installations.namePlural"
                        perPage={500}
                        reference="installations"
                        target="customer_id"
                        sort={{ field: "last_updated_at", order: "DESC" }}
                        filter={{
                            status: [
                                PROVISIONING_SUCCEEDED,
                                CONFIRMATION_EMAIL_SENT
                            ]
                        }}
                    >
                        <aor.Datagrid>
                            <aor.ReferenceField
                                reference="companies"
                                source="company_id"
                                linkType="show"
                                sortable={false}
                            >
                                <MyChipField source="name" {...props} />
                            </aor.ReferenceField>
                            <aor.UrlField
                                source="complete_installation_url"
                                target="_blank"
                                sortable={false}
                            />
                            <StatusChip
                                source="status"
                                translationRoot={"resources.events.types"}
                                sortable={false}
                            />
                            <aor.DateField
                                source="last_updated_at"
                                showTime={true}
                            />
                            <aor.TextField
                                source="installation_type_label"
                                label="resources.installations.fields.installation_type_id"
                            />
                            <aor.ShowButton />
                        </aor.Datagrid>
                    </aor.ReferenceManyField>
                )}
        </aor.SimpleShowLayout>
    </aor.Show>
);



// WEBPACK FOOTER //
// ./src/resources/Customers/Show.js